/* eslint-disable  */
import { load, ajax } from '../ws-util';

const wxGlobal = {};
const apiListGlobal = {};
const defaultApi = [
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareQZone',
  'launchApplication',
  'getNetworkType',
  'previewImage',
];
const sendingApi = {
  'wxc1fc5d34fc24f53b': [
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'showOptionMenu',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
  ]
};

const REQUEST_URL = {
  qzone: '//activity.qzone.qq.com/fcg-bin/fcg_act_weixin_jssdk_sig',
  weishi: '//api.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy/GetWXSignature'
}

const APP_ID_MAP = {
  qzone: 'wx62b3b91d3cf7c8c2',
  weishi: 'wxc1fc5d34fc24f53b',
};

const REQUEST_METHOD = {
  qzone: 'jsonp',
  weishi: 'post'
}

const sendingQueue = {};
const sending = {};

function checkApiAndDomain(appid, apiList) {
  if (!wxGlobal[appid] || !apiListGlobal[appid]) {
    return false;
  }
  for (let i = 0; i < apiList.length; i += 1) {
    if (!apiListGlobal[appid][apiList[i]]) {
      return false;
    }
  }
  return true;
}

function takeDownSendingApi(appid, apiList) {
  if (!sendingApi[appid]) {
    sendingApi[appid] = [];
  }
  /* eslint-disable-next-line */
  apiList.map((_api) => {
    if (!~sendingApi[appid].indexOf(_api)) {
      sendingApi[appid].push(_api);
    }
  });
}

function takeDownSendDefer(appid, defer) {
  if (!sendingQueue[appid]) {
    sendingQueue[appid] = [];
  }
  sendingQueue[appid].push(defer);
}

function checkSending(appid) {
  if (!sending[appid]) {
    return false;
  }
  return true;
}

function takeDownApi(api, appid, wx) {
  wxGlobal[appid] = wx;

  if (!apiListGlobal[appid]) {
    apiListGlobal[appid] = {};
  }

  api.forEach((_api) => {
    apiListGlobal[appid][_api] = true;
  });
}

function requestWxSign(opts){
  const useWeishi = opts.useWeishi;
  let key = useWeishi?'weishi':'qzone';
  const appid = APP_ID_MAP[key];
  let request = '';
  if(useWeishi){
    request = ajax.request({
      url: REQUEST_URL[key],  // 区分weish和qzone接口，默认建议暂时用qzone，等运行一段时间后再迁移weihsi
      method: REQUEST_METHOD[key],
      requestType: 'json',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        req_body:{
          url: window.location.href.replace(window.location.hash, ''),
          appid,
        }
      }),
    }).then((res)=>{
      try {
        res = JSON.parse(res);
      } catch(err) {
        console.error(err);
      }
      // 抹平返回值差异
      if(res.rsp_header.ret === 0 && res.rsp_body.signature){
        return {
          code: 0,
          data: {
          ...res.rsp_body
          }
          
        }
      }
      return res;
    });
  }else{
    request = ajax.request({
      url: REQUEST_URL[key],  // 区分weish和qzone接口，默认建议暂时用qzone，等运行一段时间后再迁移weihsi
      method: REQUEST_METHOD[key],
      params: {
        url: window.location.href.replace(window.location.hash, ''),
        appid,
      },
    }).then(res => {
      try {
        res = JSON.parse(res);
      } catch(err) {
        console.error(err);
      }
      return res;
    });
  }
  
  return request;
}
// eslint-disable-next-line no-unused-vars
export function initWXConf(opts) {
  opts = opts || {}
  console.log('opts', opts)
  // eslint-disable-next-line consistent-return
  const defer = new Promise((resolve, reject) => {
    let key = opts.useWeishi?'weishi':'qzone';
    const appid = APP_ID_MAP[key];
    load.loadJs('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
      if (!window.wx || !window.wx.config) {
        reject(appid);
      }

      const request = requestWxSign(opts);

      request.then((res) => {
        if (res.code === 0) {
          const da = res.data;
          /* eslint-disable-next-line */
          const config =  {
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            // beta: true,
            appId: appid, // 必填，公众号的唯一标识
            timestamp: da.timestamp, // 必填，生成签名的时间戳
            nonceStr: da.nonceStr, // 必填，生成签名的随机串
            signature: da.signature, // 必填，签名，见附录1
            jsApiList: sendingApi[appid], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            // openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          }
          opts.isOpenTagList && (config.openTagList = ['wx-open-launch-weapp', 'wx-open-launch-app'])
          console.log('wx init config', config)
          wx && wx.config && wx.config(config);
          /* eslint-disable-next-line */
          wx && wx.error && wx.error((err) => {
            console.log('window.wx error', err);
            // if (err.errMsg === 'config:invalid signature') {
            // }
            reject(appid, err);
          });
          window.wx.ready(() => {
            // takeDownApi(nowApi, appid, window.wx);
            console.log('window.wx ready', res);
            resolve(appid, window.wx);
          });
          console.log('weixin_jssdk_sig suc', res);
        } else {
          console.log('weixin_jssdk_sig error', res);
          reject(appid, res);
        }
      }).catch((err) => {
        console.error('weixin_jssdk_sig request error', err);
        reject(appid, {});
      });
    });
  });
  return defer;
}

export default initWXConf;
